import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "./ThemeProvider";
import { useTranslation } from "react-i18next";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const { t } = useTranslation();

  const cycleTheme = () => {
    if (theme === "system") {
      setTheme("light");
    } else if (theme === "light") {
      setTheme("dark");
    } else {
      setTheme("system");
    }
  };

  const getIcon = () => {
    if (theme === "system") {
      return <Monitor className="w-5 h-5" />;
    }
    if (theme === "light") {
      return <Sun className="w-5 h-5" />;
    }
    return <Moon className="w-5 h-5" />;
  };

  const getTooltipText = () => {
    if (theme === "system") {
      return t("theme.auto");
    }
    if (theme === "light") {
      return t("theme.light");
    }
    return t("theme.dark");
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          onClick={cycleTheme}
          className="p-2 rounded-md hover:bg-muted/50 transition-colors text-foreground/80 hover:text-foreground"
          aria-label={getTooltipText()}
        >
          {getIcon()}
        </button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{getTooltipText()}</p>
      </TooltipContent>
    </Tooltip>
  );
}
